const outlierDetectorEn = {
	outlierDetectorTable: 'Outlier Detector',
	outlierDetectorEditForm: 'Outlier Detector',
	name: 'Name',
	type: 'Type',
	imputedValue: 'Imputed value',
	max_iteration_count: 'Max iteration count',
	particle_count: 'Particle count',
	local_search_name: 'Local search name',
	train_epochs: 'Train Epochs',
	train_batch_size: 'Train batch size',
	n_estimators: 'N estimators',
	contamination: 'Contamination',
	containation: 'Containation',
	nu: 'Nu',
	kernel: 'Kernel',
	gamma: 'Gamma',
	n_neighbours: 'N Neighbours',
	encoder_dimensions: 'Encoder dimensions',
	encoder_dimensions_str: 'Encoder dimensions (comma separated)',
	decoder_dimensions: 'Decoder dimensions',
	decoder_dimensions_str: 'Decoder dimensions (comma separated)',
	novelty: 'Novelty',
	version: 'Version',
	measurement: 'Measurement',
	field: 'Field',
userGroup: 'User Group'
};

export default outlierDetectorEn;
